import React, { useState, Fragment } from "react";
import api from "../../apis/api"; // adjust path to your API
import { useHistory } from "react-router-dom";
import "../../style/login.css";


const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const history = useHistory();

  // Step 1: Send OTP
  const handleSendCode = async () => {
    if (!email.trim()) {
      setMessage("Please enter your email address.");
      return;
    }
    try {
      const res = await api.account().ForgotPassword({ email });
      setMessage(res.data.message || "Code sent to your email");
      setStep(2);
    } catch (err) {
      setMessage("User not found,Please try again.");
    }
  };

  // Step 2: Validate OTP
  const handleValidateCode = async () => {
    if (!otp.trim()) {
      setMessage("Please enter the OTP code.");
      return;
    }
    try {
      const res = await api.account().ValidateResetCode({
        email,
        otp: parseInt(otp, 10),
      });
      setMessage(res.data.message || "Code validated");
      if (res.data.success) {
        setOtp("");      // Clear OTP input
        setStep(3);
      }
    } catch (err) {
      setMessage("Invalid or expired code.");
    }
  };

 const validatePassword = (password) => {
  const minLength = /.{8,}/; // At least 8 characters
  const upperCase = /[A-Z]/; // At least one uppercase letter
  const lowerCase = /[a-z]/; // At least one lowercase letter
  const number = /[0-9]/;    // At least one digit
  const specialChar = /[!@#$%^&*(),.?":{}|<>]/; // At least one special character
 
  if (!minLength.test(password)) return "Password must be at least 8 characters long.";
  if (!upperCase.test(password)) return "Password must contain at least one uppercase letter.";
  if (!lowerCase.test(password)) return "Password must contain at least one lowercase letter.";
  if (!number.test(password)) return "Password must contain at least one number.";
  if (!specialChar.test(password)) return "Password must contain at least one special character.";
 
  return null; // Valid
};
  // Step 3: Reset Password
  const handleResetPassword = async () => {
    if (!newPassword.trim() || !confirmPassword.trim()) {
      setMessage("Please fill both password fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    const complexityError = validatePassword(newPassword);
    if (complexityError) {
      setMessage(complexityError);
      return;
    }
    try {
      const res = await api.account().ResetPassword({ email, newPassword });
      setMessage(res.data.message || "Password reset successfully.");
      if (res.data.success) {
        setNewPassword("");
        setConfirmPassword("");
        setTimeout(() => history.push("/em"), 2000); // Adjust route as needed
      }
    }
    catch (err) {
      setMessage(err.response?.data?.message || "Password reset failed.");
    }
  };

  return (
    <Fragment>
      <div className="login">
        {/* Left image same as login */}
        <div className="login-left-image"></div>

        {/* Right form box */}
        <div className="login-div forgot-div">
          <form>
            <h2 style={{ marginBottom: "20px" }}>Forgot Password</h2>
            {message && (
              <div style={{ color: "red", marginBottom: "15px" }}>{message}</div>
            )}

            {step === 1 && (
              <>

                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  type="button"
                  className="btn-login"
                  onClick={handleSendCode}
                >
                  Send Code
                </button>
                <p
                  style={{
                    display: "block",      // goes to the next line
                    marginTop: "15px",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#0c3747",
                    textAlign: "center",
                    textDecoration: "underline", // looks like a link
                  }}
                  onClick={() => history.push("/em", { fromForgotPassword: true })}
                >
                  Back to Login
                </p>
              </>
            )}

            {step === 2 && (
              <>

                <input
                  type="text"
                  placeholder="Enter the code"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <button
                  type="button"
                  className="btn-login"
                  onClick={handleValidateCode}
                >
                  Validate Code
                </button>

              </>
            )}

            {step === 3 && (
              <>

                <input
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />

                <input
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="btn-login"
                  onClick={handleResetPassword}
                >
                  Reset Password
                </button>

              </>
            )}
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
